import {Icon,} from 'antd';
//list页面form布局
export const listFormItemLayout = {
    labelCol: {
        lg: {span: 7},
        md: {span: 9},
    },
    wrapperCol: {
        lg: {span: 14},
        md: {span: 12},
    },
};
export const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        md: {
            span: 24,
            offset: 0,
        },
    },
}
/**
 * 深比较
 * @param x
 * @param y
 * @returns {boolean}
 */
export function deepCompare(x, y) {
    var i, l, leftChain, rightChain;

    function compare2Objects(x, y) {
        var p;
        // remember that NaN === NaN returns false
        // and isNaN(undefined) returns true
        if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
            return true;
        }
        // Compare primitives and functions.
        // Check if both arguments link to the same object.
        // Especially useful on the step where we compare prototypes
        if (x === y) {
            return true;
        }
        // Works in case when functions are created in constructor.
        // Comparing dates is a common scenario. Another built-ins?
        // We can even handle functions passed across iframes
        if ((typeof x === 'function' && typeof y === 'function') ||
            (x instanceof Date && y instanceof Date) ||
            (x instanceof RegExp && y instanceof RegExp) ||
            (x instanceof String && y instanceof String) ||
            (x instanceof Number && y instanceof Number)) {
            return x.toString() === y.toString();
        }
        // At last checking prototypes as good as we can
        if (!(x instanceof Object && y instanceof Object)) {
            return false;
        }
        if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
            return false;
        }
        if (x.constructor !== y.constructor) {
            return false;
        }
        if (x.prototype !== y.prototype) {
            return false;
        }
        // Check for infinitive linking loops
        if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
            return false;
        }
        // Quick checking of one object being a subset of another.
        // todo: cache the structure of arguments[0] for performance
        for (p in y) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            } else if (typeof y[p] !== typeof x[p]) {
                return false;
            }
        }
        for (p in x) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            } else if (typeof y[p] !== typeof x[p]) {
                return false;
            }
            switch (typeof(x[p])) {
                case 'object':
                case 'function':
                    leftChain.push(x);
                    rightChain.push(y);
                    if (!compare2Objects(x[p], y[p])) {
                        return false;
                    }
                    leftChain.pop();
                    rightChain.pop();
                    break;
                default:
                    if (x[p] !== y[p]) {
                        return false;
                    }
                    break;
            }
        }
        return true;
    }

    if (arguments.length < 1) {
        return true; //Die silently? Don't know how to handle such case, please help...
        // throw "Need two or more arguments to compare";
    }
    for (i = 1, l = arguments.length; i < l; i++) {
        leftChain = []; //Todo: this can be cached
        rightChain = [];
        if (!compare2Objects(arguments[0], arguments[i])) {
            return false;
        }
    }
    return true;
}
/**
 * 起运地目的地统一处理
 */
export function handleChangeArea(_this, city, cityValue, country, area, areaValue,box) {
    if (!( Array.isArray(areaValue) && areaValue.length > 0)) {
        areaValue = [..._this.state[area]]
    }
    const a = areaValue.filter(o => cityValue == o.cityName);
    const data = {
        [country]: (a.length > 0) ? a[0].countryName : '',
        [city]: cityValue,
    };
    if (areaValue) {
        data[area] = areaValue;
    }
    _this.props.form.setFieldsValue({[city]: cityValue,});
    if(box !=null && a.length > 0 ){
        _this.props.form.setFieldsValue({[box]: a[0].boxName});
    }
    _this.setState(data);
    return a;
};
/**
 * 班次时间统一处理
 * handleChangeShift(this, 'shiftDT', e, 'shiftList');
 */
export function handleChangeShift(_this, shiftDt, shiftDtValue, box, boxValue) {
    if (!( Array.isArray(boxValue) && boxValue.length > 0)) {
        boxValue = [..._this.state[box]]
    }
    const data = {
        [shiftDt]: shiftDtValue,
    };
    if (boxValue) {
        data[box] = boxValue;
    }
    _this.setState(data);
};
/**
 * 租还箱统一处理
 */
export function handleChangeRentalBox(_this, station, stationValue, box, boxValue) {
    if (!( Array.isArray(boxValue) && boxValue.length > 0)) {
        boxValue = [..._this.state[box]]
    }
    const data = {
        //[station]: stationValue == null ? boxValue[0].content : stationValue,
        [station]: stationValue,
    };
    if (boxValue) {
        data[box] = boxValue;
    }
    _this.setState(data);
};
/**
 * 货物类型选择
 * @param e
 */
// export function handleChangePackageType(_this, value, checked) {
//     if (value === 'packageTypeSmall') {
//         _this.setState({packageType1: false, packageType2: checked, packageType3: checked, packageType4: checked})
//     }
//     if ((value === 'packageTypeNormal' || value === 'packageTypeSale') && checked) {
//         _this.setState({packageType1: true, packageType2: false, packageType3: true, packageType4: true})
//     }
//     if ((value === 'packageTypeNormal' && !checked && _this.state.packageTypeSale === 'N') ||
//         (value === 'packageTypeSale' && !checked && _this.state.packageTypeNormal === 'N')) {
//         _this.setState({packageType1: false, packageType2: false, packageType3: false, packageType4: false})
//     }
//     if (value === 'packageTypeDeclare') {
//         _this.setState({packageType1: checked, packageType2: checked, packageType3: false, packageType4: checked})
//     }
//     if (value === 'packageTypeTransfer') {
//         _this.setState({packageType1: checked, packageType2: checked, packageType3: checked, packageType4: false})
//     }
//     _this.setState({[value]: checked ? 'Y' : 'N'})
// };

/**
 * 货物类型选择
 * @param e
 */
export function handleChangePackageType(_this, value) {
    var packageStatusGroup={
        'packageTypeSmall+packageTypeTransfer' : '零售小包+转关运输',
        'packageTypeSmall+packageTypeDeclare' : '零售小包+通关一体化',
        'packageTypeNormal+packageTypeSale' : '本地一般贸易+寄售代销',
        'packageTypeNormal+packageTypeDeclare' : '本地一般贸易+通关一体化',
        'packageTypeNormal+packageTypeTransfer' : '本地一般贸易+转关运输',
        'packageTypeNormalOut+packageTypeSale' : '外地一般贸易+寄售代销',
        'packageTypeNormalOut+packageTypeDeclare' : '外地一般贸易+通关一体化',
        'packageTypeNormalOut+packageTypeTransfer' : '外地一般贸易+转关运输',
        'packageTypeSale+packageTypeTransfer' : '寄售代销+转关运输',
        'packageTypeSale+packageTypeDeclare' : '寄售代销+通关一体化',
        'packageTypeB2b+packageTypeTransfer' : 'B2B直接出口+转关运输',
        'packageTypeB2b+packageTypeDeclare' : 'B2B直接出口+通关一体化',
        'packageTypeOverseas+packageTypeTransfer' :' 出口海外仓+转关运输',
        'packageTypeOverseas+packageTypeDeclare' : '出口海外仓+通关一体化'
    };
    _this.setState({
        packageTypeStatus:packageStatusGroup[value]
    })
    if (value === 'packageTypeSmall+packageTypeTransfer') {
        _this.setState({packageTypeSmall: 'Y', packageTypeTransfer: 'Y', packageTypeNormal: 'N', packageTypeSale: 'N',packageTypeDeclare:'N',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeSmall+packageTypeDeclare') {
        _this.setState({packageTypeSmall: 'Y', packageTypeTransfer: 'N', packageTypeNormal: 'N', packageTypeSale: 'N',packageTypeDeclare:'Y',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeNormal+packageTypeSale') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'N', packageTypeNormal: 'Y', packageTypeSale: 'Y',packageTypeDeclare:'N',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeNormal+packageTypeDeclare') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'N', packageTypeNormal: 'Y', packageTypeSale: 'N',packageTypeDeclare:'Y',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeNormal+packageTypeTransfer') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'Y', packageTypeNormal: 'Y', packageTypeSale: 'N',packageTypeDeclare:'N',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeNormalOut+packageTypeSale') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'N', packageTypeNormal: 'N', packageTypeSale: 'Y',packageTypeDeclare:'N',packageTypeNormalOut:'Y',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeNormalOut+packageTypeDeclare') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'N', packageTypeNormal: 'N', packageTypeSale: 'N',packageTypeDeclare:'Y',packageTypeNormalOut:'Y',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeNormalOut+packageTypeTransfer') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'Y', packageTypeNormal: 'N', packageTypeSale: 'N',packageTypeDeclare:'N',packageTypeNormalOut:'Y',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeSale+packageTypeTransfer') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'Y', packageTypeNormal: 'N', packageTypeSale: 'Y',packageTypeDeclare:'N',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeSale+packageTypeDeclare') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'N', packageTypeNormal: 'N', packageTypeSale: 'Y',packageTypeDeclare:'Y',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeB2b+packageTypeTransfer') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'Y', packageTypeNormal: 'N', packageTypeSale: 'N',packageTypeDeclare:'N',packageTypeNormalOut:'N',packageTypeB2b: 'Y',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeB2b+packageTypeDeclare') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'N', packageTypeNormal: 'N', packageTypeSale: 'N',packageTypeDeclare:'Y',packageTypeNormalOut:'N',packageTypeB2b: 'Y',packageTypeOverseas:'N'})
    }
    if (value === 'packageTypeOverseas+packageTypeTransfer') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'Y', packageTypeNormal: 'N', packageTypeSale: 'N',packageTypeDeclare:'N',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'Y'})
    }
    if (value === 'packageTypeOverseas+packageTypeDeclare') {
        _this.setState({packageTypeSmall: 'N', packageTypeTransfer: 'N', packageTypeNormal: 'N', packageTypeSale: 'N',packageTypeDeclare:'Y',packageTypeNormalOut:'N',packageTypeB2b: 'N',packageTypeOverseas:'Y'})
    }
};

export function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
}
export const IconFont = Icon.createFromIconfontCN({
    scriptUrl: 'https://at.alicdn.com/t/font_1568176_7igvd9af5sl.js',
});